<template>
  <b-dropdown
    ref="dropdown"
    @active-change="
      active => {
        show = active;
      }
    "
  >
    <button class="button" slot="trigger">
      <span>{{$tc('selling.sales')+' '+$tc('dropdown.filters')}}</span>
      <b-icon icon="menu-down"></b-icon>
    </button>

    <div class="dropdown-item" style="width: 350px;" v-if="show">
      <form @submit.prevent="onSubmit">
        <p class="title is-5">{{$tc('selling.sales')+' '+$tc('dropdown.filters')}}</p>

        <b-field :label="$tc('publisher._name')">
          <publisher-select
            can-publish
            @change="
              publisher => {
                filters.publisher = publisher;
              }
            "
          ></publisher-select>
        </b-field>

        <b-field :label="$tc('magazine')">
          <magazine-select
            @change="
              magazine => {
                filters.magazine = magazine;
              }
            "
          ></magazine-select>
        </b-field>

        <div class="columns">
          <div class="column">
            <b-field :label="$tc('dater.start')">
              <datepicker v-model="filters.createdAtSince"></datepicker>
            </b-field>
          </div>

          <div class="column">
            <b-field :label="$tc('dater.end')">
              <datepicker v-model="filters.createdAtUntil"></datepicker>
            </b-field>
          </div>
        </div>

        <b-field :label="$tc('pay.balance')">
          <b-select v-model="filters.distributed" expanded>
            <option :value="null">All</option>
            <option :value="true">Paid balance</option>
            <option :value="false">Payable balance</option>
          </b-select>
        </b-field>

        <button class="button is-primary">
          <b-icon icon="magnify"></b-icon>
          <span>{{$tc('search.search')}}</span>
        </button>
      </form>
    </div>
  </b-dropdown>
</template>

<script>
import BaseForm from "../../../../../components/BaseFilterForm";
import PublisherSelect from "../../selectors/PublisherSelect";
import MagazineSelect from "../../selectors/MagazineSelector";

export default {
  components: {
    PublisherSelect,
    MagazineSelect
  },

  mixins: [BaseForm],

  methods: {
    fresh() {
      return {
        publisher: null,
        magazine: null,
        createdAtSince: null,
        createdAtUntil: null
      };
    }
  }
};
</script>
